/**
 * Bare-UUID form of the nil-user identifier used in document roles.
 *
 * NOTE: hardcoded in firestore.rules — do not change the value.
 *
 * @deprecated Prefer `NIL_ANONYMOUS_UID` (`any-anon_` prefixed) from
 * `@buildwithflux/identifiers-schema` (or `/legacy`) for new code.
 */
export const ANON_ROLE_UID = "0338f920-f103-45be-9462-2cae879caa37";

/**
 * List of Flux user UIDs that should not count towards billable editor counts
 */
export const NON_BILLABLE_FLUX_USER_UIDS = ["dQV3OMncTEVcOpwIwe1ivV70My52"] as const;

/**
 * UID of the official Flux Support user.
 */
export const FLUX_SUPPORT_USER_UID = "dQV3OMncTEVcOpwIwe1ivV70My52";

/**
 * Organization UID for the "Flux Support" org (handle: "support").
 * Used when granting support access to user projects from the bug report dialog.
 */
export const FLUX_SUPPORT_ORG_UID = "org_b57684db-b8e9-4dc5-bcc3-cb134802db34";

/**
 * Organization UID for the "Flux Review Team" org (handle: "review").
 * Used when granting review access to user projects from the expert-review flow.
 */
export const FLUX_REVIEW_ORG_UID = "org_a3c0db2f-f2ae-4f51-adc5-462568cff321";

/**
 * UID of the official Flux Review user (handle: "review-user").
 */
export const FLUX_REVIEW_USER_UID = "TRW9GxgTeCcWes44efFYZ4PHeDf1";
